document.addEventListener('DOMContentLoaded', () => {
  // BO Code for scroll to feature on PDP
  const scrollButton = document.querySelector('.rating');
  const scrollButtonAlt = document.querySelector('.rating-count');
  const targetElement = document.querySelector('.pdp-richtext');

  if (targetElement) {
    [scrollButton, scrollButtonAlt].forEach(btn => {
      if (btn) {
        btn.addEventListener('click', () => {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
      }
    });
  }
  // EO Code for scroll to feature on PDP

    document.querySelectorAll('.custom-accordion .accordion-heading').forEach(heading =>
        heading.addEventListener('click', event => {
            event.stopPropagation();
            const item = heading.closest('.accordion-item');
            item.classList.toggle('open', !item.classList.contains('open'));
            document.querySelectorAll('.accordion-item').forEach(i => {
                if (i !== item) i.classList.remove('open');
            });
        })
    );
    document.querySelectorAll('.custom-accordion .close').forEach(closeButton =>
        closeButton.addEventListener('click', event => {
            event.stopPropagation();
            closeButton.closest('.accordion-item').classList.remove('open');
        })
    );
    document.addEventListener('click', event => {
        if (!document.querySelector('.custom-accordion').contains(event.target)) {
            document.querySelectorAll('.accordion-item.open').forEach(item => item.classList.remove('open'));
        }
    });
    // Toggle inner accordion buttons
    document.querySelectorAll('.inner-accordion .accordion-button').forEach(button =>
        button.addEventListener('click', () => button.classList.toggle('active'))
    );
});



// $(document).ready(function () {
//   const storageKey = 'user_country';
//   const expiryKey = 'user_country_expiry';
//   const now = new Date().getTime();
//   const oneDay = 24 * 60 * 60 * 1000;

//   const storedCountry = localStorage.getItem(storageKey);
//   const storedExpiry = localStorage.getItem(expiryKey);

 
//   if (storedCountry && storedExpiry && now < parseInt(storedExpiry)) {
//     updateHeader(storedCountry);
//   } else {
//     updateHeader(null);
//   }

  
//   fetch("https://ipapi.co/json/")
//     .then(res => res.json())
//     .then(data => {
//       const code = data.country_code;
//       if (code === 'DE') {
//         localStorage.setItem(storageKey, 'DE');
//         localStorage.setItem(expiryKey, now + oneDay);
//         updateHeader('DE');
//       } else {
//         localStorage.removeItem(storageKey);
//         localStorage.removeItem(expiryKey);
//         updateHeader(null);
//       }
//     })
//     .catch(err => {
//       console.warn("GeoIP error:", err);
//     });

//   function updateHeader(code) {
//     if (code === 'DE') {
//       $('.general-header').hide();
//       $('.germany-header').css('display', 'grid');
//     } else {
//       $('.germany-header').hide();
//       $('.general-header').css('display', 'grid');
//     }
//   }
// });



$(document).ready(function () {
  const cookieName = 'user_country';
  const cookieDuration = 86400; 

 
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  
  function setCookie(name, value, seconds) {
    const expires = new Date(Date.now() + seconds * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  
  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  }

  const storedCountry = getCookie(cookieName);
  if (storedCountry === 'DE') {
    updateHeader('DE');
  } else {
    updateHeader(null);
  }

  
  fetch("https://ipapi.co/json/")
    .then(res => res.json())
    .then(data => {
      const code = data.country_code;
      if (code === 'DE') {
        setCookie(cookieName, 'DE', cookieDuration); // set for 1 day
        updateHeader('DE');
      } else {
        deleteCookie(cookieName);
        updateHeader(null);
      }
    })
    .catch(err => {
      console.warn("GeoIP error:", err);
    });

  
  function updateHeader(code) {
    // if (code === 'DE') {
    //   $('.general-header').hide();
    //   $('.germany-header').css('display', 'grid');
    // } else {
      $('.germany-header').hide();
      $('.general-header').css('display', 'grid');
    // }
  }
});
